export default __webpack_public_path__ + "static/media/me_filled-min.8687d591.png";